import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { UsersService } from "../services/users.service";
import { take } from "rxjs/operators";
import { UserRole } from "../../../../common/src/lib/models/user-profile.model";
import { BusinessService } from "../services/business.service";
import { showSnackbar } from "../../../../common/src/lib/components/snackbar/snackbar.component";
import { MatLegacySnackBar } from "@angular/material/legacy-snack-bar";


export const canViewBusiness = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const usersService = inject(UsersService);
    const router = inject(Router);
    const currentUser = await usersService.currentUser$.pipe(take(1)).toPromise();

    if(currentUser.status.includes('suspended'))
        return router.createUrlTree(['/suspended']);

    return true;
};

export const canViewSuspendedPage = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {

    const usersService = inject(UsersService);
    const router = inject(Router);
    const currentUser = await usersService.currentUser$.pipe(take(1)).toPromise();
    if(currentUser.status.includes('suspended'))
        return true;

    return router.createUrlTree(['/lobby']);
};

export const canViewNuveiApplication = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const usersService = inject(UsersService);
    const businessService = inject(BusinessService);
    const router = inject(Router);
    const snackbar = inject(MatLegacySnackBar);
    const businesses = await businessService.availableBusinesses$.pipe(take(1)).toPromise();
    if(businesses.length === 0)
        return router.createUrlTree(['/lobby']);
    const currentUser = await usersService.currentUser$.pipe(take(1)).toPromise();
    if(currentUser.role === 'owner') {
        return true;
    }
    showSnackbar(snackbar, { message: "Unauthorized" });
    return router.createUrlTree(['/lobby']);
};